import React, { useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import CustomButton from "../../components/CustomButton";
import { Link, useNavigate } from "react-router-dom";
import CheckEligibilityModal from "../home/components/checkEligibility/modal/EligibilityModal";
import { Modal } from "@mantine/core";

const StartFileClaim = () => {
  const navigate = useNavigate();
  const [openEligibility, setOpenEligibility] = useState(false);
  const [openInstructModal,setOpenInstructModal]=useState(false)

  const handleStartClaim = () => {
    const keysToRemove = [
      "travelerInformationData",
      "claimType",
      "OriginallyBookedFlightsData",
      "actualFlightDetailsData",
      "completedStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
    navigate("/file-claim");
  }

  const handleEligibilityCheck = () => {
    const keysToRemove = [
      "claimType",
      "flightDetailsData",
      "flightCheckData",
      "claimQuestionsData",
      "emailAgreementData",
      "eligibilityStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
    setOpenEligibility(true);
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <CheckEligibilityModal
        open={openEligibility}
        close={setOpenEligibility}
      />

        <Modal
            opened={openInstructModal}
        onClose={() => { setOpenInstructModal(false); handleStartClaim()}}
        size={'xl'}
        closeOnClickOutside={false}
            withCloseButton={true}
        padding={0}
        styles={{
          header: {
            padding:"0px 15px"
          }
        }}
      >
        
        <div className="instruct-modal-wrapper
        
        ">

          <h2>
            Please have the following information available to you before starting a claim.
          </h2>

          <ul>
            <li>All travelers’ details (last name, first name, DOB etc.)</li>
            <li>All travelers ticket numbers, Airline reservation Code (PNR)</li>
            <li>All travelers Passports to upload.</li>
            <li>Originally booked flight details (Airline name , Flight number, departing city and time – arriving city and time)</li>
            <li>Actual flown flight details (Airline name , Flight number, departing city and time – arriving city and time)</li>
            <li>All expenses receipts related to your claim</li>
           
           
          </ul>

           <p style={{textAlign:"center",color:"#ff4b4bff",borderColor:"#ff4b4bff",background:"rgb(255 170 170 / 5%)",borderRadius:"6px"}}>Please upload complete flight details for the direction of the incident</p>
       
          <p style={{margin:"10px 0"}}> If the claim is for more than one person, a power of attorney document will be generated at the end of the process.

Please print out, have it signed by all travelers in the claim and upload back so we can start the claim process.</p>
        </div>


            </Modal>


      <Nav />
      <div className="modal-wrapper">
        <div className="modal-main-wrapper start-file-claim-container">
          <div className="start-file-claim-card">
            <h2>Start your claim in just a few minutes!</h2>
            <p>
              Answer a few questions to check your eligibility or submit your
              claim now
            </p>
            <div className="start-file-claim-buttons">
              {/* <Link to={"/claimstatus"}> */}
              {/* <CustomButton
                onClick={handleEligibilityCheck}
                btnText="Check Eligibility"
                type="secondary"
                disabled={true}
              /> */}
              {/* </Link> */}
              <CustomButton
                // style={{ marginLeft: "20px" }}
                onClick={()=>{setOpenInstructModal(true);}}
                btnText={"Start My Claim"}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StartFileClaim;
